var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNascar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#00853E;stroke:#94CA5F;stroke-width:2;stroke-miterlimit:10;}\n\t.bg-fill{fill:#FFFFFF;stroke:#767777;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#767777;stroke-width:2;stroke-miterlimit:10;}\n\t.st4{display:inline;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.icon-outline{fill:#767777;}\n\t.st8{fill:#00853E;stroke:#00853E;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#00853E;}\n\t.st10{display:inline;fill:#767777;}\n\t.st11{fill:#00853E;stroke:#04662E;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{display:inline;fill:none;stroke:#767777;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#959696;stroke-width:5;stroke-miterlimit:10;}\n\t.st14{display:inline;fill:#888888;}\n\t.st15{display:inline;fill:none;stroke:#888888;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{display:inline;fill:none;stroke:#959696;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#888888;}\n\t.st18{fill:none;stroke:#888888;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#959696;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{display:inline;fill:#FFFFFF;}\n\t.st21{display:inline;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{display:inline;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{display:inline;fill:none;stroke:#767777;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:#F2F2F2;}\n\t.st27{fill:none;stroke:#F2F2F2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st28{display:inline;fill:none;stroke:#F2F2F2;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st29{display:inline;fill:#F2F2F2;}\n\t.st30{display:inline;fill:none;stroke:#767777;stroke-width:2;stroke-miterlimit:10;}\n\t.st31{display:inline;fill:#767777;stroke:#767777;stroke-miterlimit:10;}\n\t.st32{display:inline;fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st33{display:inline;fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st34{display:inline;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st35{display:inline;fill:none;stroke:#888888;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st36{fill:none;stroke:#888888;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st37{display:inline;fill:none;stroke:#888888;stroke-miterlimit:10;}\n\t.st38{display:inline;fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st39{display:inline;fill:none;stroke:#888888;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st40{fill:#959696;}\n\t.st41{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st42{fill:none;stroke:#F09938;stroke-width:3;stroke-miterlimit:10;}\n\t.st43{fill:none;stroke:#EBA73B;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:9.821,9.821;}\n\t.st44{fill:none;stroke:#EBA73B;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:10.175,10.175;}\n\t.st45{fill:none;stroke:#EBA73B;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Colored_BG"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg-fill",
    d: "M60.4,69H10.3c-5,0-9.1-4.1-9.1-9.1V10.1C1.3,5,5.3,1,10.3,1h50.1c5,0,9.1,4.1,9.1,9.1v49.9 C69.5,65,65.5,69,60.4,69z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Original",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 23.4,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -7.0387 6.3279)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 21,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -5.929 8.503)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 18.6,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -4.8193 10.678)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28.4,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -8.6868 5.7981)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 25.9,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -7.577 7.9732)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 23.5,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -6.4673 10.1483)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 30.9,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -9.2188 7.4402)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 28.4,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -8.109 9.6153)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7,
    y: 26,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -6.9993 11.7903)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 35.8,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -10.8668 6.9104)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 33.4,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -9.7571 9.0855)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 31,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -8.6474 11.2605)",
    className: "st17",
    width: 3.9,
    height: 3.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M36.9,33.3l-21.6,7c-0.2,0.1-0.5-0.1-0.6-0.3L10,25.6c-0.1-0.2,0.1-0.5,0.3-0.6L32,18 c0.2-0.1,0.5,0.1,0.6,0.3l4.7,14.4C37.3,33,37.2,33.2,36.9,33.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 32.3,
    y1: 17.3,
    x2: 42.9,
    y2: 49.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 23.8,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 112.6084 69.4146)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 21.4,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 98.8917 62.4162)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.1,
    y: 19,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 85.1751 55.4178)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 28.8,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 115.9493 79.8078)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26.4,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 102.2326 72.8094)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 24,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 88.5159 65.811)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 31.3,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 105.5938 83.1628)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28.9,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 91.8771 76.1644)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.6,
    y: 26.5,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 78.1605 69.166)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 36.2,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 108.9347 93.5559)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 33.8,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 95.218 86.5575)",
    className: "st17",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.1,
    y: 31.4,
    transform: "matrix(-0.9509 -0.3094 0.3094 -0.9509 81.5013 79.5591)",
    className: "st17",
    width: 3.9,
    height: 3.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M41,33.6l22.2,7.2c0.1,0,0.2,0,0.2-0.1l4.9-15c0-0.1,0-0.2-0.1-0.2L46,18.3c-0.1,0-0.2,0-0.2,0.1l-4.9,15 C40.9,33.5,40.9,33.6,41,33.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 46,
    y1: 17.7,
    x2: 35.4,
    y2: 50.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Outlined"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.3,
    y: 27,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -8.0997 6.7376)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 24.6,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -6.9884 8.9108)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 31.9,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -9.7401 6.2031)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 29.5,
    transform: "matrix(0.9509 -0.3094 0.3094 0.9509 -8.6303 8.3782)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8,
    y: 27.4,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 8.5302 70.3935)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 25,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 5.703 61.6776)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 32.3,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 5.5885 76.1635)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9,
    y: 29.9,
    transform: "matrix(0.3094 -0.9509 0.9509 0.3094 2.7613 67.4474)",
    className: "icon-outline",
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "M64.8,26.3c-0.1-0.2-0.3-0.4-0.5-0.4l-23.2-7.4c0,0,0,0,0,0L35,37.2L28.8,18c0,0,0-0.1-0.1-0.1l-1.4,0.5 c0,0,0,0,0,0l-0.5,0.2l0,0l0,0L5.9,25.4c-0.6,0.2-1,0.9-0.8,1.5l4.7,14.4c0.1,0.3,0.3,0.6,0.6,0.7c0.2,0.1,0.4,0.1,0.5,0.1 c0.1,0,0.3,0,0.4-0.1l21.4-7l1.5,4.5l-3.7,11.5c-0.1,0.4,0.1,0.8,0.5,0.9c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5L35,42l3,9.1 c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.2,0,0.2,0c0.4-0.1,0.6-0.6,0.5-0.9l-3.6-11.1l1.3-4.1l21.7,7.1c0.1,0,0.2,0,0.3,0 c0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.4-0.3,0.4-0.5l4.9-15C64.9,26.8,64.9,26.5,64.8,26.3z M29.3,34.7l-1-3.2l-3.7,1.2l1,3.2l-3.7,1.2 l-1-3.2l-3.7,1.2l1,3.2l-3.7,1.2l-1-3.2l-3.3,1.1l-1.2-3.8l3.3-1.1L11,28.9l-3.3,1.1l-1.1-3.3l3.3-1.1l1,3.2l3.7-1.2l-1-3.2 l3.7-1.2l1,3.2l3.7-1.2l-1-3.2l3.7-1.2l1,3.2l2.9-1l1.2,3.8l-2.9,1l1.2,3.7l2.9-1l1,3.2L29.3,34.7z M62.2,30.4l-3.3-1.1L57.7,33 L61,34l-1.2,3.8l-3.3-1.1l-1,3.2l-3.7-1.2l1-3.2l-3.7-1.2l-1,3.2l-3.7-1.2l1-3.2l-3.7-1.2l-1,3.2l-3-1l1-3.2l2.9,1l1.2-3.7 l-2.9-1l1.2-3.8l2.9,1l1-3.2l3.7,1.2l-1,3.2l3.7,1.2l1-3.2l3.7,1.2l-1,3.2l3.7,1.2l1-3.2l3.3,1.1L62.2,30.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNascar);
export default __webpack_public_path__ + "static/media/nascar.203f3ef1a51c93894e36e5c7d6ac7bed.svg";
export { ForwardRef as ReactComponent };